import { render } from "./ServiceItsSliderRegularComp.vue?vue&type=template&id=2abb8240&scoped=true"
import script from "./ServiceItsSliderRegularComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsSliderRegularComp.vue?vue&type=script&lang=js"

import "./ServiceItsSliderRegularComp.vue?vue&type=style&index=0&id=2abb8240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abb8240"]])

export default __exports__